export const jsonParse = value => {
  try {
    return JSON.parse(value)
  } catch (error) {
    return null
  }
}

export const jsonStringify = value => {
  try {
    return JSON.stringify(value)
  } catch (error) {
    return null
  }
}
